import React from 'react'

import cx from 'classnames'

import { Input } from '@driftt/tide-core'

import styles from '../styles.module.css'

const CheckboxRow: React.FC<any> = ({
  field,
  form,
  content,
  inverse,
  onChange = null,
  checkedCondition = null
}) => {
  return (
    <div
      className={cx(styles.row, styles.clickable)}
      onClick={(e: any) => {
        const clickedIcon =
          e?.target?.className?.baseVal?.indexOf?.('tide-icon tide-select-dropdown-indicator') > -1
        const clickedSelectMenu = e?.target?.className?.indexOf?.('tide-select') > -1
        if (clickedIcon || clickedSelectMenu) {
          return
        }
        if (onChange) {
          onChange()
        } else {
          form.setFieldValue(field.name, !field.value)
          form.setFieldTouched(field.name)
        }
      }}>
      {content}
      <Input
        {...field}
        onChange={() => {}}
        onBlur={() => form.setFieldTouched(field.name)}
        checked={
          typeof checkedCondition === 'boolean'
            ? checkedCondition
            : inverse
            ? !field.value
            : field.value
        }
        type="checkbox"
      />
    </div>
  )
}

export default CheckboxRow
